import {Navigate, Outlet, useLocation, useParams} from "react-router-dom";
import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import i18n from "../i18n";

export const SUPPORTED_LANGS = ["fa", "ar-IQ"] as const;
export const DEFAULT_LANG = "fa";

export const base = (process.env.REACT_APP_MARKET_BASE_PATH || "").replace(/\/$/, "");
export const withBase = (path: string) => `${base}${path}`;

export function getActiveLang(): string {
    if (typeof window !== "undefined") {
        const stripped = window.location.pathname.slice(base.length);
        const firstSegment = stripped.split("/").filter(Boolean)[0];
        if (SUPPORTED_LANGS.includes(firstSegment as any)) {
            return firstSegment;
        }
    }
    if (SUPPORTED_LANGS.includes(i18n.language as any)) {
        return i18n.language;
    }
    return DEFAULT_LANG;
}

export const withLang = (path: string, lang?: string) => {
    const activeLang = lang && SUPPORTED_LANGS.includes(lang as any) ? lang : getActiveLang();
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    return `${base}/${activeLang}${normalizedPath}`;
};

function LangLayout() {
    const {lang} = useParams();
    const {i18n} = useTranslation();
    const {pathname, search, hash} = useLocation();

    const isValid = SUPPORTED_LANGS.includes(lang as any);

    useEffect(() => {
        if (isValid && lang) {
            if (i18n.language !== lang) {
                i18n.changeLanguage(lang);
            }
            document.documentElement.lang = lang;
            document.documentElement.dir = "rtl";
        }
    }, [lang, isValid, i18n]);

    // First segment isn't a language -> treat whole path as lang-less and redirect
    if (!isValid) {
        const stripped = pathname.slice(base.length); // "/home/5"
        return (
            <Navigate
                to={`${base}/${DEFAULT_LANG}${stripped}${search}${hash}`}
                replace
            />
        );
    }

    return <Outlet/>;
}

export default LangLayout;
